export function throttle(func, ms) {

  let isThrottled = false;
  let timeout = null;
    
  wrapper.clearTimeout = () => clearTimeout(timeout);

  function wrapper() {
    if (isThrottled) {
      return;
    }

    func.apply(this, arguments);

    isThrottled = true;

    timeout = setTimeout(function() {
      isThrottled = false;
    }, ms);
  }

  return wrapper;
}